import React from "react";
import "./hors-connexion.scss";

/**
 * Gabarit des écrans hors connexion (connexion, activation, nouveau mot de
 * passe) : volet marque à gauche, carte à droite. Les enfants sont le contenu
 * de la carte. Les deux logos sont ceux déjà servis depuis public/assets.
 */
const PageHorsConnexion = ({ children }) => (
  <div className="hors-connexion">
    <aside className="marque" aria-label="Présentation d'ESPOAR">
      <div className="disque" />
      <div>
        <img className="logo" src="/assets/logo-espoar-new.png" alt="ESPOAR" />
        <h1>Espace administratif</h1>
        <p className="accroche">
          Suivi et accompagnement des bénéficiaires du RSA à La Réunion : orientations, équipes
          pluridisciplinaires, rendez-vous et échanges avec France Travail.
        </p>
      </div>
      <div className="pied">
        <span className="caf">
          <img src="/assets/logo-espoar.png" alt="Caf de La Réunion" />
        </span>
        <span>
          Une plateforme de la Caf de La Réunion
          <br />
          réservée aux professionnels habilités
        </span>
      </div>
    </aside>
    <main className="acces">
      <div className="carte">{children}</div>
    </main>
  </div>
);

export default PageHorsConnexion;
